import type {
  ContactOrderAppointmentRow,
  ContactOrderPlanningOperations,
  ContactOrderPlanningSurfacePayloadBuilder,
  RowCommunicationSelection,
} from "../../../_logic/contact-orders-contract"
import { automaticCommunicationSelectionForPlanningRow } from "../../../_logic/selection-state"

/** Resolve defaults through the existing read-only batch port, never from a manually edited preview. */
export const loadAutomaticPreconfiguration = async ({
  rows,
  buildPayloads,
  previewContactOrders,
  caseIdByOrderId,
  allowedContactChannels,
}: {
  rows: ContactOrderAppointmentRow[]
  buildPayloads: ContactOrderPlanningSurfacePayloadBuilder
  previewContactOrders: ContactOrderPlanningOperations["previewContactOrders"]
  caseIdByOrderId: Record<string, string | null>
  allowedContactChannels: readonly string[]
}): Promise<Record<string, RowCommunicationSelection>> => {
  if (!rows.length) return {}

  const payloads = buildPayloads({
    targetEvents: rows.map((row) => row.event),
    appointmentRows: rows,
    caseIdByOrderId,
    communicationSelectionByEventId: {},
    allowedContactChannels,
    includeInactiveRows: true,
  })
  const result = await previewContactOrders(payloads)
  const rowsByEventId = new Map(rows.map((row) => [row.event.id, row]))
  const selections: Record<string, RowCommunicationSelection> = {}
  for (const preview of result.previews ?? []) {
    const payload = payloads[preview.index]
    const eventId = payload?.schedule_event_id
    const row = eventId ? rowsByEventId.get(eventId) : undefined

    if (
      !row ||
      (preview.schedule_event_id && preview.schedule_event_id !== eventId) ||
      (preview.work_order_id && preview.work_order_id !== row.event.work_order_id)
    )
      continue

    selections[String(row.id)] = automaticCommunicationSelectionForPlanningRow(
      { ...row, planningPreview: preview },
      allowedContactChannels,
    )
  }

  return selections
}
